export default __webpack_public_path__ + "static/media/icon_withdraw.29572b6d.svg";